import * as React from 'react'
import './styles.scss'

interface IPropsInputLabel {
  label: string
}

const InputLabel = ({ label }: IPropsInputLabel) => {
  return (
    <div className="inputText__label">
      <p>
        <span>{label}</span>
      </p>
    </div>
  )
}

export interface WrappedFieldMetaProps {
  active?: boolean | undefined;
  autofilled: boolean;
  asyncValidating: boolean;
  dirty: boolean;
  dispatch: any;
  error?: any;
  form: string;
  initial: any;
  invalid: boolean;
  pristine: boolean;
  submitting: boolean;
  submitFailed: boolean;
  touched: boolean;
  valid: boolean;
  visited: boolean;
  warning?: any;
}
interface IProps {
  placeholder?: string
  initialValues?: string
  label?: string
  Icon?: any
  secondary?: boolean
  onChange?: (value: string) => void
  styles?: React.CSSProperties
  meta?: WrappedFieldMetaProps
}

export const InputText = (props: IProps) => {
  const { initialValues, onChange, placeholder, label, secondary, Icon,meta, styles={} } = props
  const [value, setValue] = React.useState(initialValues)
  const [isInputFocus, setFocus] = React.useState(false)

  const isFocus = (value && value?.length > 0 || (isInputFocus && value && value?.length > 0)) ? 'inputText__active' : ''
  const inputPlaceholder = placeholder || 'Recherche...'

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange && onChange(e.target.value)
    setValue(e.target.value)
  }

  const onInputBlur = () => value && value.length > 0 ? setFocus(true) : setFocus(false)

  React.useEffect(() => {
    setValue(initialValues)
  }, [initialValues])

  return (
    <div className={`inputText ${isFocus} ${secondary ? 'inputText--secondary' : ''}`}>
      { label && !secondary && InputLabel({ label }) }

      <div style={styles} className={`inputText__container ${meta?.touched && meta?.error ? 'inputText__error' : ''}`}>
        { Icon ? (
          <div className="inputText__icon">
            <Icon />
          </div>
        ) : '' }
        <input
          type="text"
          className="inputText__input"
          placeholder={!secondary ? inputPlaceholder : ''}
          value={value ?? ''}
          onBlur={onInputBlur}
          onChange={onInputChange}
        />
        {
          secondary && (
            <div style={{ position: 'absolute', left: '32px' }}>{value && value?.length > 0 ? value : inputPlaceholder}</div>
          )
        }
      </div>
    </div>
  );
}
